/**
 * Project: redwood-ui-components
 * FilePath: /src/client/app/applications/papyrus-search-quick/TableConfig.js
 * File: TableConfig.js
 * Created Date: Friday, April 5th 2019, 11:42:59 am
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Apr 05 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Pixel Ventures Ltd.
 * ------------------------------------
 */

import PapyrusQuickSearch from './SearchQuick'

export const PapyrusQuickSearchConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [{
    path: '/papyrus-search-quick',
    component: PapyrusQuickSearch
  }]
}
